import React from 'react';
function Attention({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9 9 0 100-18 9 9 0 000 18z"
        clipRule="evenodd"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4" />
      <path d="M12.5 16.5a.5.5 0 10-1 0 .5.5 0 001 0z" />
    </svg>
  );
}

export default Attention;
